import createIcon from '../../createIcon';

/**
 * @component @name ModeOfTravel
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuNTYgMTguOUMxMi42IDE5LjkgMTEuNSAyMC45MyAxMC4yNSAyMkM0LjkyIDE3LjQ1IDIuMjUgMTMuNTIgMi4yNSAxMC4yQzIuMjUgNS4yMiA2LjA1IDIgMTAuMjUgMkMxNC4yNSAyIDE3Ljg5IDQuOTIgMTguMjIgOS41SDIxLjc1TDE3LjI1IDE0TDEyLjc1IDkuNUgxNi4yMkMxNS45IDYuMjQgMTMuMzggNCAxMC4yNSA0QzYuOSA0IDQuMjUgNi41NyA0LjI1IDEwLjJDNC4yNSAxMi41NCA2LjIgMTUuNjQgMTAuMjUgMTkuMzRDMTAuODkgMTguNzUgMTEuNDggMTguMTggMTIuMDIgMTcuNjNDMTEuODUgMTcuMjkgMTEuNzUgMTYuOTEgMTEuNzUgMTYuNTFDMTEuNzUgMTUuMTMgMTIuODcgMTQuMDEgMTQuMjUgMTQuMDFDMTUuNjMgMTQuMDEgMTYuNzUgMTUuMTMgMTYuNzUgMTYuNTFDMTYuNzUgMTcuODkgMTUuNjMgMTkgMTQuMjUgMTlDMTQuMDEgMTkgMTMuNzggMTguOTcgMTMuNTYgMTguOVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ModeOfTravel = createIcon('ModeOfTravel', [
  [
    'path',
    {
      d: 'M13.56 18.9C12.6 19.9 11.5 20.93 10.25 22C4.92 17.45 2.25 13.52 2.25 10.2C2.25 5.22 6.05 2 10.25 2C14.25 2 17.89 4.92 18.22 9.5H21.75L17.25 14L12.75 9.5H16.22C15.9 6.24 13.38 4 10.25 4C6.9 4 4.25 6.57 4.25 10.2C4.25 12.54 6.2 15.64 10.25 19.34C10.89 18.75 11.48 18.18 12.02 17.63C11.85 17.29 11.75 16.91 11.75 16.51C11.75 15.13 12.87 14.01 14.25 14.01C15.63 14.01 16.75 15.13 16.75 16.51C16.75 17.89 15.63 19 14.25 19C14.01 19 13.78 18.97 13.56 18.9Z',
      key: '1p8v4t',
    },
  ],
]);

export default ModeOfTravel;
